import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'
import { TableRow as BaseRow, TableCell as BaseTableCell, Toast as BaseToast } from '@chilecompra/react-kit/components'

export const AnnotationsToast = styled(BaseToast)`
  &.MuiAlert-root {
    .MuiAlert-icon {
      margin-rigth: 10px;
    }
    .MuiAlert-message {
      color: ${props => props.theme.palette.brand.black2};
      font-family: Roboto;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 18px;
      padding: 7px 0;
      width: 100%;
    }
  }
`

export const Column = styled(({ flexBasis, flexGrow, width, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    flex-basis: ${props => props.flexBasis};
    flex-grow: ${props => props.flexGrow};
    margin: 0;
    padding: 0 5px;
    width: ${props => props.width};
  }
`

export const Content = styled('section')`
  font-size: 14px;
  line-height: 18px;
  overflow-x: auto;
  padding-top: 14px;
  width: 100%;
`

export const Paragraph = styled('p')`
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 9px;
  margin-top: 0;
`

export const Row = styled(({ ...props }) => <BaseGrid container {...props} />)`
  &.MuiGrid-root {
    margin: 0 -5px;
    padding: 0;
  }
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 8px 0;
  overflow: visible;
`

export const TableRow = styled(BaseRow)`
  .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root:first-of-type {
    padding: 15px 8px;
  }
`

export const TableCellName = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: ${props => props.padding || '12px 9px 16px'};

    &:first-child {
      color: ${props => props.theme.palette.custom.bigStone};
      font-family: Roboto;
      font-size: 12px;
      height: 18px;
      letter-spacing: 0;
      line-height: 18px;
      padding: ${props => props.padding || '12px 9px 16px 0'};
      width: 61px;
    }
  }
`
